import { useState, useEffect } from 'react';
import { useWindowSize } from 'react-use';
import { isBrowser } from '@web3/base-utils';

interface ScreenSizeProps {
  size?: number;
}

export const getScreenType = (
  width: number = isBrowser ? window.innerWidth : 0,
  height: number = isBrowser ? window.innerHeight : 0
) => {
  return {
    isMobile: width <= 640,
    isMd: width > 640 && width <= 1200,
    isXl: width > 1200,
    height,
    width,
  };
};

export const useScreenType = () => {
  const { width, height } = useWindowSize();
  return getScreenType(width, height);
};

export default function useScreenSize({ size }: ScreenSizeProps): boolean {
  const [windowSize, setWindowSize] = useState<any>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    // only execute all the code below in client side
    if (typeof window !== 'undefined') {
      // Handler to call on window resize
      const handleResize = () => {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };

      // Add event listener
      window.addEventListener('resize', handleResize);

      // Call handler right away so state gets updated with initial window size
      handleResize();

      // Remove event listener on cleanup
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize && windowSize.width
    ? windowSize.width <= (size || 480)
    : false;
}

export function updateFontSize(fontSize: number) {
  const topWindow = window.top || window;
  const dom = topWindow.document.documentElement;
  if (dom?.style) {
    dom.style.fontSize = `${fontSize}px`;
  }
}

export function useRem(
  remConfig: {
    breakpointWidth?: number;
    designWidth?: number;
  } = {}
) {
  const { breakpointWidth } = remConfig;
  useEffect(() => {
    if (!isBrowser) return;
    // only execute all the code below in client side
    // Handler to call on window resize
    const handleResize = () => {
      // Set window root fontsize
      // 没有设置则说明不需要h5，直接设置为16px
      if (!breakpointWidth) {
        updateFontSize(16);
        return;
      }

      const html = document.documentElement;
      const clientWidth = html.clientWidth;
      // var dpr = window.devicePixelRatio || 1
      if (clientWidth >= breakpointWidth) {
        updateFontSize(16);
        return;
      }

      const { designWidth = 375 } = remConfig;

      if (designWidth) {
        const fontSize = (clientWidth / designWidth) * 16;
        updateFontSize(fontSize);
      }
    };

    // Add event listener
    window.addEventListener('resize', handleResize);
    // window.addEventListener('pageshow', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);
}
